import React, { useEffect, useState } from "react";
import { Phone, Mail, MapPin, Send, CheckCircle2 } from "lucide-react";
import axios from "axios";
import { siteData } from "../mock";
import SEO from "../components/SEO";
import { PAGE_META } from "../data/pageMeta";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Contact() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const [sent, setSent] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });

  const submit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/contact`, form);
      setSent(true);
      setForm({ name: "", email: "", phone: "", message: "" });
      setTimeout(() => setSent(false), 4000);
    } catch (err) {
      if (process.env.NODE_ENV === "development") console.error(err);
      localStorage.setItem("contact_msg_fallback", JSON.stringify({ ...form, at: Date.now() }));
      setSent(true);
      setForm({ name: "", email: "", phone: "", message: "" });
      setTimeout(() => setSent(false), 4000);
    }
  };

  return (
    <section className="container-tight py-20">
      <SEO
        {...PAGE_META["/contact"]}
      />
      <div className="max-w-2xl mb-14">
        <span className="chip mb-4">Contact</span>
        <h1 className="font-serif text-5xl md:text-6xl font-medium text-[#1a1815] tracking-tight leading-[1.05]">
          Prenons contact
        </h1>
        <p className="mt-4 text-lg text-[#4a4642]">
          Une question ? Un besoin spécifique ? Écrivez-moi ou appelez-moi, je vous réponds rapidement.
        </p>
      </div>

      <div className="grid lg:grid-cols-5 gap-8">
        <div className="lg:col-span-2 space-y-4">
          <div className="bg-white rounded-3xl border border-[#e8e0d5] p-7">
            <div className="w-11 h-11 rounded-xl bg-[#f7f2ec] flex items-center justify-center mb-4">
              <Phone size={20} className="text-[#d97757]" />
            </div>
            <h3 className="font-serif text-lg font-medium text-[#1a1815]">Téléphone</h3>
            <a href={`tel:${siteData.practitioner.phone.replace(/\s/g, "")}`} className="mt-1 block text-[#4a4642] hover:text-[#d97757]">{siteData.practitioner.phone}</a>
          </div>

          <div className="bg-white rounded-3xl border border-[#e8e0d5] p-7">
            <div className="w-11 h-11 rounded-xl bg-[#f7f2ec] flex items-center justify-center mb-4">
              <Mail size={20} className="text-[#d97757]" />
            </div>
            <h3 className="font-serif text-lg font-medium text-[#1a1815]">Email</h3>
            <p className="mt-1 text-[#4a4642]">jc.happillon@gmail.com</p>
          </div>

          <div className="bg-white rounded-3xl border border-[#e8e0d5] p-7">
            <div className="w-11 h-11 rounded-xl bg-[#f7f2ec] flex items-center justify-center mb-4">
              <MapPin size={20} className="text-[#d97757]" />
            </div>
            <h3 className="font-serif text-lg font-medium text-[#1a1815]">Zone d'intervention</h3>
            <p className="mt-1 text-[#4a4642] text-sm leading-relaxed">
              Toulouse, Quint-Fonsegrives, Balma, Saint-Orens, Labège, Escalquens, L'Union, Saint-Jean, Flourens, Drémil-Lafage, Ramonville, Castanet-Tolosan et environs.
            </p>
          </div>
        </div>

        <form onSubmit={submit} className="lg:col-span-3 bg-white rounded-3xl border border-[#e8e0d5] p-8">
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="text-xs uppercase tracking-widest text-[#8a8580] font-medium">Prénom & nom</label>
              <input
                required
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                className="mt-2 w-full rounded-xl border border-[#e8e0d5] px-4 py-3 bg-[#fbf8f4] focus:border-[#d97757] focus:outline-none focus:bg-white transition-colors"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest text-[#8a8580] font-medium">Téléphone</label>
              <input
                value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
                className="mt-2 w-full rounded-xl border border-[#e8e0d5] px-4 py-3 bg-[#fbf8f4] focus:border-[#d97757] focus:outline-none focus:bg-white transition-colors"
              />
            </div>
          </div>
          <div className="mt-4">
            <label className="text-xs uppercase tracking-widest text-[#8a8580] font-medium">Email</label>
            <input
              required
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="mt-2 w-full rounded-xl border border-[#e8e0d5] px-4 py-3 bg-[#fbf8f4] focus:border-[#d97757] focus:outline-none focus:bg-white transition-colors"
            />
          </div>
          <div className="mt-4">
            <label className="text-xs uppercase tracking-widest text-[#8a8580] font-medium">Votre message</label>
            <textarea
              required
              rows={5}
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              className="mt-2 w-full rounded-xl border border-[#e8e0d5] px-4 py-3 bg-[#fbf8f4] focus:border-[#d97757] focus:outline-none focus:bg-white transition-colors resize-none"
            />
          </div>
          <button type="submit" className="btn-primary mt-6">
            Envoyer le message <Send size={16} />
          </button>
          {sent && (
            <div className="mt-5 flex items-center gap-2 text-[#2e7d3f] bg-[#e8f5e9] rounded-xl p-3 text-sm fade-in">
              <CheckCircle2 size={18} /> Message envoyé. Je vous réponds au plus vite.
            </div>
          )}
        </form>
      </div>
    </section>
  );
}
